import React from 'react';

export interface AchievementData {
  milestone: number;
  title: string;
  description: string;
  emojis: string[];
  numberText: string;
}

export interface AchievementCardProps {
  achievement?: AchievementData | null;
  isEmpty?: boolean;
  className?: string;
}

const AchievementCard: React.FC<AchievementCardProps> = ({
  achievement,
  isEmpty = false,
  className = ""
}) => {
  if (isEmpty || !achievement) {
    return (
      <div className={`flex flex-col items-center justify-center text-center ${className}`}>
        <div className="text-[24px] font-bold text-white mb-2">0</div>
        <div className="text-[10px] text-white">Start your journey</div>
      </div>
    );
  }

  return (
    <div className={`flex flex-col ${className}`}>
      {/* Title with emojis - always show the dynamic title */}
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-[12px] font-bold text-white font-roboto">{achievement.title}</h3>
        <div className="flex items-center space-x-1">
          {achievement.emojis.map((emoji, index) => (
            <span key={index} className="text-[12px]">{emoji}</span>
          ))}
        </div>
      </div>

      {/* Large number */}
      <div className="text-[32px] font-bold text-white text-center mb-2">
        {achievement.numberText}
      </div>

      {/* Description */}
      <div className="text-[10px] font-light text-white text-center">
        completed class!
      </div>
    </div>
  );
};

export default AchievementCard;
